export const countryMap = {
  IN: "India", 
  AU: "Australia",
  AT: "Austria",
  BE: "Belgium",
  BN: "Brunei",
  CA: "Canada",
  CH: "Switzerland",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DK: "Denmark",
  EE: "Estonia",
  ES: "Spain",
  FI: "Finland",
  FR: "France",
  GB: "United Kingdom",
  GR: "Greece",
  HU: "Hungary",
  IT: "Italy",
  LT: "Lithuania",
  LV: "Latvia",
  MA: "Morocco",
  MT: "Malta",
  NL: "Netherlands",
  NO: "Norway",
  NZ: "New Zealand",
  PT: "Portugal",
  RU: "Russia",
  SE: "Sweden",
  SG: "Singapore",
  SI: "Slovenia",
  SM: "San Marino",
  TH: "Thailand",
  TR: "Turkey",
  TW: "Taiwan",
  UA: "Ukraine",
  US: "United States"
};
